import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
function ProductForm({ initialData, onSubmit, buttonText }) {
  const [preview, setPreview] = useState("");

  const [features, setFeatures] = useState([""]);

  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    category: "",
    brand: "",
    price: "",
    oldPrice: "",
    stock: "",
    image: null,
    description: "",
  });
 const navigate = useNavigate();
  useEffect(() => {
    if (!initialData) return;

    setFormData({
      title: initialData.title || "",
      slug: initialData.slug || "",
      category: initialData.category || "",
      brand: initialData.brand || "",
      price: initialData.price || "",
      oldPrice: initialData.oldPrice || "",
      stock: initialData.stock || "",
      image: null,
      description: initialData.description || "",
    });

    setFeatures(
      Array.isArray(initialData.features) ? initialData.features : [""],
    );

    const IMAGE_URL =
      process.env.NODE_ENV === "production"
        ? "https://polybionictechnologies.com"
        : "http://localhost:5001";

    setPreview(
      initialData.image ? `${IMAGE_URL}/uploads/${initialData.image}` : "",
    );
  }, [initialData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData({
        ...formData,
        image: file,
      });

      setPreview(URL.createObjectURL(file));
    }
  };

  const handleFeatureChange = (index, value) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };

  const addFeature = () => {
    setFeatures([...features, ""]);
  };

  const removeFeature = (index) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      data.append("title", formData.title);
      data.append("slug", formData.slug);
      data.append("category", formData.category);
      data.append("brand", formData.brand);
      data.append("price", formData.price);
      data.append("oldPrice", formData.oldPrice);
      data.append("stock", formData.stock);
      data.append("description", formData.description);
      data.append("features", JSON.stringify(features));

      if (formData.image) {
        data.append("image", formData.image);
      }

      await onSubmit(data);
      // Success ke baad redirect
      navigate("/dashboard/products");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form onSubmit={submitHandler} className="space-y-6">
      <div className="grid md:grid-cols-2 gap-5">
        {/* Product Name */}
        <div>
          <label className="block mb-2 font-medium">Product Name</label>

          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter Product Name"
            className="w-full border p-3 rounded-lg"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">Product Slug</label>

          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            placeholder="Enter Product slug"
            className="w-full border p-3 rounded-lg"
            required
          />
        </div>

        {/* Category */}
        <div>
          <label className="block mb-2 font-medium">Category</label>

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full border p-3 rounded-lg"
            required
          >
            <option value="">Select Category</option>
            <option value="Hydroponic Systems">Hydroponic Systems</option>
            <option value="Nutrients">Nutrients</option>
            <option value="Grow Lights">Grow Lights</option>
            <option value="Seeds">Seeds</option>
            <option value="Growing Media">Growing Media</option>
          </select>
        </div>

        {/* Brand */}
        <div>
          <label className="block mb-2 font-medium">Brand</label>

          <select
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            className="w-full border p-3 rounded-lg"
          >
            <option value="">Select Brand</option>
            <option value="Polybionics">Polybionics</option>
            <option value="HydroFarm">HydroFarm</option>
          </select>
        </div>

        {/* Price */}
        <div>
          <label className="block mb-2 font-medium">Price (₹)</label>

          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter Price"
            className="w-full border p-3 rounded-lg"
            required
          />
        </div>

        {/* Old Price */}
        <div>
          <label className="block mb-2 font-medium">Old Price (₹)</label>

          <input
            type="number"
            name="oldPrice"
            value={formData.oldPrice}
            onChange={handleChange}
            placeholder="Enter Old Price"
            className="w-full border p-3 rounded-lg"
          />
        </div>

        {/* Stock */}
        <div>
          <label className="block mb-2 font-medium">Stock Quantity</label>

          <input
            type="number"
            name="stock"
            value={formData.stock}
            onChange={handleChange}
            min="0"
            className="w-full border p-3 rounded-lg"
            required
          />

          {formData.stock > 10 && (
            <p className="text-green-600 text-sm mt-2">✓ In Stock</p>
          )}

          {formData.stock > 0 && formData.stock <= 10 && (
            <p className="text-yellow-600 text-sm mt-2">⚠ Low Stock</p>
          )}

          {formData.stock === "0" && (
            <p className="text-red-600 text-sm mt-2">✕ Out of Stock</p>
          )}
        </div>

    
   
      
      </div>

      {/* Product Image */}
      <div>
        <label className="block mb-2 font-medium">Product Image</label>

        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="w-full border p-3 rounded-lg"
        />

        {preview && (
          <img
            src={preview}
            alt="Preview"
            className="mt-4 w-40 h-40 object-cover rounded-lg border"
          />
        )}
      </div>

      {/* Features */}
      <div>
        <label className="block mb-2 font-medium">Features</label>

        {features.map((feature, index) => (
          <div key={index} className="flex gap-2 mb-2">
            <input
              type="text"
              value={feature}
              onChange={(e) => handleFeatureChange(index, e.target.value)}
              placeholder="Enter Feature"
              className="flex-1 border p-3 rounded-lg"
            />

            <button
              type="button"
              onClick={() => removeFeature(index)}
              className="px-4 bg-red-500 text-white rounded-lg"
            >
              ✕
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addFeature}
          className="bg-green-600 text-white px-4 py-2 rounded-lg"
        >
          + Add Feature
        </button>
      </div>

      {/* Description */}
      <div>
        <label className="block mb-2 font-medium">Description</label>

        <textarea
          name="description"
          rows="5"
          value={formData.description}
          onChange={handleChange}
          placeholder="Product Description"
          className="w-full border p-3 rounded-lg"
        />
      </div>

      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg"
      >
        {buttonText}
      </button>
    </form>
  );
}

export default ProductForm;
